import AbstractProvider from '../services/App/AbstractProvider';
import {IDatabase} from '../@interfaces/services/Database';
import {IStoreEvents} from '../@interfaces/services/StoreEvents/IStoreEvents';
import {setModelPreloadedConfigs} from '../_redux/model-configs/actions';
import ModelConfig from '../services/Database/Models/ModelConfig';
import {MODEL_CONFIGS_SET} from '../_redux/model-configs/constants';
import {StringArray} from '../@interfaces/types';

export class ModelConfigsProvider extends AbstractProvider {
	holdBootUntilNotCompleted = false;

	async boot(): Promise<void> {
		this.subscribeToStoreEvents();

		if (!this.app.config.get('client.store-data-in-db') as boolean) {
			return;
		}

		const table = this.getStoredService<IDatabase>('db').modelsConfigs;
		if (!table) {
			return;
		}

		const configs = await new ModelConfig().getStoredConfigs();
		if (configs && Object.keys(configs).length === 2) {
			this.app.dispatchAction(setModelPreloadedConfigs(configs));
		}
	}

	protected subscribeToStoreEvents() {
		const dispatcher = this.getStoredService<IStoreEvents>('store-events');

		dispatcher.listen(MODEL_CONFIGS_SET, (e, payload) => {
			const actionPayload = payload.action.payload;
			if (!actionPayload.configs) {
				return;
			}

			Object.keys(actionPayload.configs).map(name => {
				if (!actionPayload.configs[name]) {
					return Promise.resolve();
				}

				return ModelConfig.updateOrCreate<ModelConfig>({
					name: name,
					model: actionPayload.controllerName
				}, {
					config: actionPayload.configs[name] as StringArray<any>
				});
			});
		});
	}
}
